// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from '../icon/Icon'

@Component({
    name: 'Loading',
    components: {
        Icon,
    },
    mixins: [
        template,
    ]
})
export class Loading extends Vue {

    public isLoading: boolean = false
    public isSuccess: boolean = false
    public isError: boolean = false

    @Prop()
    public value!: boolean

    @Prop({default: 0})
    public activeQueue!: number

    @Prop({default: true})
    public auto!: boolean

    @Prop()
    public success!: boolean

    @Prop({default: 750})
    public hideAnimationDuration!: number

    @Watch('value')
    public watchValue(value: boolean) {

        if (!value && value != this.isLoading) {

            this.success ? this.isSuccess = true :  this.isError = true

            this.$emit('update:activeQueue', 0)

            this.hideLoader()
        } else if (value && value != this.isLoading) { this.isLoading = true }
    }

    public beforeCreate() {
    }

    public created () {

        this.isLoading = this.value
    }

    private hideLoader() {

        setTimeout(() => {
            this.isSuccess = false
            this.isError = false
            this.isLoading = false
            this.$emit('input', false)
        }, this.hideAnimationDuration)
    }
}